import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

const ConfirmDeleteImageDialog = ({ onClose, onDelete, imageName, image }) => {
    const handleDelete = e => {
        e.preventDefault();
        onDelete(imageName);
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle sx={{ wordWrap: 'break-word' }}>Delete image: {imageName}</DialogTitle>
            <DialogContent>
                <Alert severity="warning">Are you sure you want to delete this image from your account?</Alert>
                <img src={image.link} alt={imageName} style={{ maxWidth: '100%', maxHeight: '300px', display: 'block', margin: 'auto', marginBottom: '20px', marginTop: '20px' }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDelete}>Delete</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteImageDialog;